import { render } from "./FAQFeedbackButton.vue?vue&type=template&id=d28b12fa"
import script from "./FAQFeedbackButton.vue?vue&type=script&lang=js"
export * from "./FAQFeedbackButton.vue?vue&type=script&lang=js"
script.render = render

export default script